import { getToken } from "./tokenStore";
import { handleSessionOut } from "../Components/Components";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const VERSION_CHECK_CLIENTS_API = process.env.REACT_APP_VERSION_CHECK_CLIENTS;

export const getDCPGridData = async (payload) => {
  const response = await fetch(`${backendUrl}/uploads_list`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(payload).toString(),
  });

  if (!response.ok) throw new Error("ExchangeOAuth failed");
  const data = await response.json();
  return data;
};

export async function v2Clients() {
  const token = getToken();
  const response = await fetch(`${VERSION_CHECK_CLIENTS_API}/v2_clients`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  if (response && response?.status !== 200) {
    await handleSessionOut();
  }
  return data;
}
